/**
 * @extends storeLocator.StaticDataFeed
 * @constructor
 */
function DaiwaDataSource() {
    $.extend(this, new storeLocator.StaticDataFeed);
  
    var that = this;
    $.get('https://daiwa-au-b2c.devotedigital.workers.dev/?type=fishing-locations&range=A:ZZ', function (data) {
      var csv = '';
      for (i = 0; i < data.valueRanges['0'].values.length; i++) {
        var cellData = [];
        for (x = 0; x < data.valueRanges['0'].values[i].length; x++) {
          cellData[x] = data.valueRanges['0'].values[i][x].replace(',', ';');
        }
        csv += cellData + '\n';
      }
      that.setStores(that.parse_(csv)); 
    });
  }
  /**
   * @const
   * @type {!storeLocator.FeatureSet}
   * @private
   */
  
  DaiwaDataSource.prototype.FEATURES_ = new storeLocator.FeatureSet(
    new storeLocator.Feature('Saltwater-Yes', 'Saltwater'),
    new storeLocator.Feature('Freshwater-Yes', 'Freshwater'),
    new storeLocator.Feature('BoatRamp-Yes', 'BoatRamp'),
  );
    
  
  /**
   * @return {!storeLocator.FeatureSet}
   */
  DaiwaDataSource.prototype.getFeatures = function () {
    return this.FEATURES_;
  };
  
  /**
   * @private
   * @param {string} csv
   * @return {!Array.<!storeLocator.Store>}
   */
  DaiwaDataSource.prototype.parse_ = function (csv) {
  
    var stores = [];
    var rows = csv.split('\n');
    var headings = this.parseRow_(rows[0]);
    for (var i = 1; i < rows.length; i++) {
  
      var singleCell = rows[i].split(',');
      var singleHead = headings[0].split(',');
      var singleObject = {};
      for (var x = 0; x < singleHead.length; x++) {
        if (singleCell[x] != null && singleCell[x] != '') {
          var cleanCell = singleCell[x].replace(";", ",")
          var cleanHeader = singleHead[x].replace(/(\r\n|\n|\r)/gm, "");
          singleObject[cleanHeader] = cleanCell;
        }
      }
  
      var position = new google.maps.LatLng(singleObject.Latitude, singleObject.Longitude);
      var shop = this.join_([singleObject.Address, singleObject.City], ', ');
      var locality = this.join_([singleObject.State, singleObject.Postcode], ', ');
      var directions = new storeLocator.Feature('2', '<a class="action directions" href="https://www.google.com/maps/search/?api=1&query=' + shop.split(' ').join('+') + ',' + locality.split(' ').join('+') + '" onclick="clickDirectionStore(\'' + singleObject.Name + '\')" target="_blank">DIRECTIONS</a>');
      
      console.log(singleObject.Spot_Name);
      var targetSpecies = JSON.stringify(singleObject.Target_Species)
      var bestBait = JSON.stringify(singleObject.Best_Bait);
      var bestLure = JSON.stringify(singleObject.Best_Lure);
      var bestSource = JSON.stringify(singleObject.Source);

      if(targetSpecies != undefined) {
        var target_species = new storeLocator.Feature('3', '<p class="font-weight-bold m-0">Target Species</p>' + '<p class="popup-text">' + targetSpecies.replace(/\"/g, "") + '</p>');
      }
      else {
        var target_species = new storeLocator.Feature('3', '');
      }

      if(bestBait != undefined) {
        var best_bait = new storeLocator.Feature('4', '<p class="font-weight-bold m-0">Best Bait</p>' + '<p class="popup-text">' + bestBait.replace(/\"/g, "") + '</p>');
      }
      else {
        var best_bait = new storeLocator.Feature('4', '');
      }
      
      if(bestLure != undefined) {
        var best_lure = new storeLocator.Feature('5', '<p class="font-weight-bold m-0">Best Lure</p>' + '<p class="popup-text">' + bestLure.replace(/\"/g, "") + '</p>');
      }
      else {
        var best_lure = new storeLocator.Feature('5', '');
      }

      if(bestSource != undefined) {
        var source = new storeLocator.Feature('6','<p class="font-weight-bold popup-text">' + bestSource.replace(/\"/g, "") + '</p>');
      }
      else {
        var source = new storeLocator.Feature('6','');
      }

      var features = new storeLocator.FeatureSet(target_species, best_bait, best_lure, source, directions); 

      // var features = new storeLocator.FeatureSet;
      features.add(this.FEATURES_.getById(singleObject.Phone));
      features.add(this.FEATURES_.getById(singleObject.Name));
      features.add(this.FEATURES_.getById('Saltwater-' + singleObject.Saltwater));
      features.add(this.FEATURES_.getById('Freshwater-' + singleObject.Freshwater));
      features.add(this.FEATURES_.getById('BoatRamp-' + singleObject.BoatRamp));
  
      if (singleObject.Phone == null) {
        var isTelHidden = 'd-none';
      } else {
        var isTelHidden = '';
      }
  
      var store = new storeLocator.Store(i, position, features, {
        title: singleObject.Spot_Name,
        address: this.join_([shop, locality], '<br>'),
        category: 'https://cdn.shopify.com/s/files/1/0060/3770/0678/files/' + singleObject.Category + '-marker.png'
      });
      stores.push(store);
    }
  
    return stores;
  
  };

  $('.popup-text').each(function() {
    $(this).text().replace(/"/g, "");
  })
  
  
  /**
   * Joins elements of an array that are non-empty and non-null.
   * @private
   * @param {!Array} arr array of elements to join.
   * @param {string} sep the separator.
   * @return {string}
   */
  DaiwaDataSource.prototype.join_ = function (arr, sep) {
    var parts = [];
    for (var i = 0, ii = arr.length; i < ii; i++) {
      arr[i] && parts.push(arr[i]);
    }
    return parts.join(sep);
  };
  
  /**
   * Very rudimentary CSV parsing - we know how this particular CSV is formatted.
   * IMPORTANT: Don't use this for general CSV parsing!
   * @private
   * @param {string} row
   * @return {Array.<string>}
   */
  DaiwaDataSource.prototype.parseRow_ = function (row) {
    // Strip leading quote.
    if (row.charAt(0) == '"') {
      row = row.substring(1);
    }
    // Strip trailing quote. There seems to be a character between the last quote
    // and the line ending, hence 2 instead of 1.
    if (row.charAt(row.length - 2) == '"') {
      row = row.substring(0, row.length - 2);
    }
  
    row = row.split('","');
  
    return row;
  };
  
  /**
   * Creates an object mapping headings to row elements.
   * @private
   * @param {Array.<string>} headings
   * @param {Array.<string>} row
   * @return {Object}
   */
  DaiwaDataSource.prototype.toObject_ = function (headings, row) {
    var result = {};
    for (var i = 0, ii = row.length; i < ii; i++) {
      result[headings[i]] = row[i];
    }
    return result;
  };